import * as React from "react"
import {ModalSeeker} from "@ui-seeker/core"

import { productPageImageDetailsDataModal } from "../@signals"
import ProductPagesImagesModalContainer from "./ImagesContainer"


export default function ProductPagesImagesDetailModal() {
    const isOpen = productPageImageDetailsDataModal.value !== null

    return <ModalSeeker
        hideActions
        title={'Images In Gallery'}
        isOpen={isOpen}
        controller={() => productPageImageDetailsDataModal.value = null}
        containerProps={{ maxWidth: "xl" }}
    >
        { isOpen && <ProductPagesImagesModalContainer keyData={'imagesInGallery'} /> }
    </ModalSeeker>
}